<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { Background } from "@infinitro/background";
import { Text } from "@infinitro/text";
export let item = null;
</script>

<div class="step-card">
	<div class="step-container">
		{#if item}
			<div class="fog"></div>
			<img src={item.img} alt={$t(Verbiage.reward_alt, 'alts')} class="reward-img" />
		{/if}
	</div>

	<div>
		<Background
			starQuantity={150}
			rounded={true}
			maxSizeStar={2}
			small={true}
			noGradient={true}
			noFigures={true}
		/>

		<div class="step-text">
			<div class="step-title">
				{#if item && item.title}
					<Text type="title" titleSize="h5" textAlign={'center'}>{$t(Verbiage[item.title])}</Text>
				{/if}
			</div>

			<div class="step-description">
				{#if item && item.description}
					<Text type="body" titleSize="h5" textColor="gray" bodySize="small" textAlign={'center'}
						>{$t(Verbiage[item.description])}</Text
					>
				{/if}
			</div>
		</div>
	</div>
</div>

<style>
	.step-card {
		position: relative;
		display: flex;
		height: auto;
		max-height: 340px;
		min-height: 320px;
		width: 100%;
		min-width: 100px;
		max-width: 260px;
		flex-shrink: 0;
		flex-direction: column;
		align-items: center;
		justify-content: flex-end;
		gap: 0.5rem;
		border-radius: 0.5rem;
		border-width: 2px;
		padding: 0.5rem;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		padding-top: 16rem;
		border-color: #2c3763;
}
	@media (min-width: 1024px) {
		.step-card {
				padding: 1.25rem;
		}
	}

	.step-text {
		display: flex;
		width: 100%;
		flex-direction: column;
		align-items: center;
		gap: 0.25rem;
		text-align: center;
}

	.step-title {
		width: 9rem;
		font-size: 1.125rem;
		line-height: 1.75rem;
}
	@media (min-width: 1024px) {
		.step-title {
				width: 12rem;
		}
	}

	.step-description {
		width: 9rem;
		font-size: 1.125rem;
		line-height: 1.75rem;
}
	@media (min-width: 1024px) {
		.step-description {
				width: 12rem;
		}
	}

	.step-container {
		position: relative;
		margin-top: -540px;
	}

	.reward-img {
		position: relative;
		z-index: 2;
		transform: translateY(0);
}

	.fog {
		position: absolute;
		inset: 0px;
		border-radius: 9999px;
		background-color: #bf5af2;
		opacity: 0.5;
		filter: blur(20px);
		inset: 11.5%;
		z-index: 0;
		pointer-events: none;
}
</style>
